<template lang="pug">
  .b2b-page-auditoria
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('auditory_detail.info_auditory') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("auditory_detail.buttons.request_tooltip")', placement='bottom')
                ods-button(
                  v-if='audit.pathRequest!==null',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='handlePeticion')
                  | {{ $t('auditory_detail.buttons.request') }}
              ods-tooltip(:content='$t("auditory_detail.buttons.response_tooltip")', placement='bottom')
                ods-button(
                  v-if='audit.pathResponse!==null',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='handleRespuesta')
                  | {{ $t('auditory_detail.buttons.response') }}
              ods-tooltip(:content='$t("auditory_detail.buttons.incoming_file_tooltip")', placement='bottom')
                ods-button(
                  v-if='audit.incomingFile!==null',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='handleFicheroEntrada')
                  | {{ $t('auditory_detail.buttons.incoming_file') }}
              ods-tooltip(:content='$t("auditory_detail.buttons.integrated_file_tooltip")', placement='bottom')
                ods-button(
                  v-if='audit.pathFile!== null',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='handleFichero')
                  | {{ $t('auditory_detail.buttons.integrated_file') }}

      ods-row
        b2b-timeline(:events='events', type='auditory')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-auditorias',
  mixins: [Utils],
  data () {
    return {
      id: '',
      audit: {
        pathRequest: null,
        pathResponse: null,
        pathFile: null,
        incomingFile: null
      },
      events: []
    }
  },

  components: {
    B2bTimeline
  },

  watch: {
    '$route' (to) {
      this.id = to.params.idAuditDocument
    }
  },
  computed: {
    ...mapGetters([
      // Permisos
      'canSeeEvents'
    ])
  },

  methods: {
    ...mapActions([
      'getAuditDocumentById',
      'getAuditsEvents',
      'handleDownloadEntryRequestAudit',
      'handleDownloadExitRequestAudit',
      'handleDownloadOriginalAudit',
      'handleDownloadInAudit'
    ]),

    // Desargar Petición
    async handlePeticion () {
      console.log('handlePeticion() ->')
      const load = this.$loading({
        lock: true,
        text: this.$t('auditory_detail.load.download_request_file')
      })
      try {
        if (this.id && this.id !== undefined) {
          const filename = await this.handleDownloadEntryRequestAudit(this.id)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('handleEntryRequestAudit CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Desargar Respuesta
    async handleRespuesta () {
      console.log('handleRespuesta() ->')
      const load = this.$loading({
        lock: true,
        text: this.$t('auditory_detail.load.download_response_file')
      })
      try {
        if (this.id && this.id !== undefined) {
          const filename = await this.handleDownloadExitRequestAudit(this.id)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('handleExitRequestAudit CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleFichero () {
      console.log('handleFichero() ->')
      const load = this.$loading({
        lock: true,
        text: this.$t('auditory_detail.load.download_original_file')
      })
      try {
        if (this.id && this.id !== undefined) {
          const filename = await this.handleDownloadOriginalAudit(this.id)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('handleDownloadOriginalAudit CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleFicheroEntrada () {
      console.log('handleFicheroEntrada() ->')
      const load = this.$loading({
        lock: true,
        text: this.$t('auditory_detail.load.download_incoming_file')
      })
      try {
        if (this.id && this.id !== undefined) {
          const filename = await this.handleDownloadInAudit(this.id)
          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        console.log('handleDownloadOriginalAudit CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 500:
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })

    try {
      // Get auditory document
      this.audit = await this.getAuditDocumentById(this.$route.params.idAuditDocument)
      this.id = this.$route.params.idAuditDocument

      // Get Events
      if (this.canSeeEvents && this.id && this.id !== undefined) {
        this.events = await this.getAuditsEvents(this.id)
      }
    } catch (error) {
      console.log('getEvents CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-auditoria{
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
